import Flickity from "flickity"
import "flickity-imagesloaded"
import Drift from "drift-zoom"
import GLightbox from 'glightbox'
import Modal from './components/modal'

export default class SingleProduct {
    constructor(element) {
        this.product = element
        this.imageCarousel = this.product.querySelector('.product-image-carousel')
        this.imageCarouselPrevButton = this.product.querySelector('.product-images-carousel-button-left')
        this.imageCarouselNextButton = this.product.querySelector('.product-images-carousel-button-right')
        this.images = this.product.querySelectorAll('.product-image-thumbnails-thumbnail')
        this.variationsForm = this.product.querySelector('.variations_form')
        this.productPrice = this.product.querySelector('.product-price-inner')
        this.productSalePrice = this.product.querySelector('.product-sale-price')
        this.productSalePriceComplete = this.product.querySelector('.product-sale-price-wrapper')
        this.productPriceComplete = this.product.querySelector('.product-price')
        this.productUnavailable = this.product.querySelector('.product-info-unavailable')


        // Initialize components
        this.carouselObject = this.initCarousel()
        this.initRelatedProductsCarousel()
        this.initLightbox()
        this.initZoom()

        // Listen to variation changes
        if (this.variationsForm) {
            this.variationsData = JSON.parse(this.variationsForm.getAttribute('data-product_variations'))
            this.selects = this.product.querySelectorAll('.cart-button-variations select')
            this.button = this.product.querySelector('.ajax-button')
            this.buttonNotAvailable = this.product.querySelector('.ajax-button-disabled')

            // Run handleSelectChange when page loads to ensure correct price
            this.handleSelectChange()

            // A visitor selects a variation
            this.selects.forEach((select) => {
                select.addEventListener('change', () => this.handleSelectChange())
            })

        }
    }

    handleSelectChange() {
        // Collect the value of all the selects
        let variation = {}
        this.selects.forEach((select) => {
            const attribute_id = select.getAttribute('id').replace(/\s/g, '-').toLowerCase()
            variation[`attribute_${attribute_id}`] = select.value;
        })

        // Reset the variation_id in button
        this.button.setAttribute('data-variation_id', '0');

        //Reset the price to visible and unavailable to invisible
        this.productPriceComplete.style.display = "block"
        if (this.productSalePrice && this.productSalePriceComplete.style.display) {
            this.productSalePrice.style.display = "inline"
            this.productSalePriceComplete.style.display = "inline"
        }

        this.productUnavailable.style.display = "none"

        //Reset button
        this.button.style.display = "flex"
        this.buttonNotAvailable.style.display = "none"
        this.button.classList.remove("button-disabled")

        //Flag
        let found = false

        this.variationsData.forEach((item) => {
            let variationAttributes = Object.keys(item['attributes'])

            let anyAttributeMatched = false
            variationAttributes.forEach((attribute) => {
                if (item['attributes'][attribute] === variation[attribute]) {
                    anyAttributeMatched = true
                }
            })

            if (anyAttributeMatched) {
                found = true
                this.updateCarousel(item['image_id'])
                if (item['is_purchasable'] && item['is_in_stock']) {
                    this.button.setAttribute('data-variation_id', item['variation_id']);
                    this.updatePrice(item);
                } else {
                    this.variationUnavailable()
                }
            } else {
                return false;
            }

        })

        if (!found) {
            this.variationUnavailable()
        }
    }

    updatePrice(item) {

        this.productPrice.innerHTML = item['display_price'].toFixed(2).replace('.', ',')

        if (this.productSalePrice) {
            this.productSalePrice.innerHTML = item['display_regular_price'].toFixed(2).replace('.', ',')
        }
    }

    updateCarousel(image) {
        let imageCarouselElement = this.imageCarousel.querySelector(`[data-image-id='${image}']`)

        if (imageCarouselElement) {
            this.carouselObject.select(parseInt(imageCarouselElement.getAttribute('data-index')))
        }
    }

    variationUnavailable() {
        this.productPriceComplete.style.display = "none"
        if (this.productSalePrice) {
            this.productSalePrice.style.display = "none"
            this.productSalePriceComplete.style.display = "none"
        }
        this.productUnavailable.style.display = "block"
        this.button.classList.add("button-disabled")
        this.button.style.display = "none"
        this.buttonNotAvailable.style.display = "flex"
    }

    initZoom() {
        const imagesCarousel = this.product.querySelectorAll('.drift-zoom')
        const paneContainer = this.product.querySelector('.product-info')

        imagesCarousel.forEach((image) => {
            new Drift(image, {
                paneContainer: paneContainer,
            })
        })
    }

    initLightbox() {
        const lightbox = GLightbox({
            selector: '.lightbox',
        })

        this.images.forEach((item) => {
            item.addEventListener('click', () => lightbox.open())
        })
    }

    initRelatedProductsCarousel() {
        new Flickity(this.product.querySelector('.product-related-products'), {
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left',
            imagesLoaded: true,
        })
    }

    initCarousel() {
        const flickity = new Flickity(this.imageCarousel, {
            pageDots: false,
            prevNextButtons: false,
            on: {
                ready: () => {
                    if (this.images[0]) {
                        this.images[0].classList.add('active')
                    }
                }
            }
        })

        flickity.on('select', (index) => {
            this.images.forEach((thumbnail) => {
                thumbnail.classList.remove('active')
                if (thumbnail.getAttribute('data-id') === index) {
                    thumbnail.classList.add('active')
                }
            })
        })

        this.imageCarouselPrevButton.addEventListener('click', function () {
            flickity.previous(true)
        })

        this.imageCarouselNextButton.addEventListener('click', function () {
            flickity.next(true)
        })

        return flickity
    }
}